// frontend/src/components/Common/GoBackButton.js (0.2.0)

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { motion } from 'framer-motion';

/**
 * Componente de botão para voltar na navegação
 * 
 * @param {Function} onClick - Função customizada para executar ao clicar (opcional)
 * @param {string} to - Rota específica para navegar (opcional)
 * @param {string} className - Classes CSS adicionais (opcional)
 */
const GoBackButton = ({ onClick, to, className = '' }) => {
    const navigate = useNavigate();

    /**
     * Handler para o clique do botão
     * Prioridade: onClick > to > navigate(-1)
     */
    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (to) {
            navigate(to);
        } else {
            navigate(-1);
        }
    };

    return (
        <motion.button
            onClick={handleClick}
            className={`
                flex items-center gap-1 text-gray-600 
                hover:text-higeia-accent transition 
                font-medium text-sm
                p-1 rounded-lg
                ${className}
            `}
            whileHover={{ x: -2 }}
        >
            <ChevronLeft size={20} />
            Voltar
        </motion.button>
    );
};

export default GoBackButton;